@file:OptIn(ExperimentalSerializationApi::class)

package dk.rheasoft.csaware.api.incident

import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.Serializable

@Serializable
data class CourseOfAction(
        var id: String,
        var name: String = "",
        var description: String = "",
        var action: String = ""
)
